export default __webpack_public_path__ + "static/media/CSD.c4ab0f01.png";